import { versionDate } from './versionDate';

export const environment = {
  production: false,
  developmentMode: false,
  isStandalonePortal: true,
  isLocal: true,
  isvOidcBaseUrl:
    'https://30188881-maas360.verify.ibm.com/oidc/endpoint/default',
  isvSamlBaseUrl:
    'https://30188881-maas360.verify.ibm.com/saml/sps/saml20sp/saml20',
  isvBaseUrl: 'https://30188881-maas360.verify.ibm.com',
  client_id: '3f4e5845-093c-422a-b05e-55e2d48afe86',
  client_secret: '9iqUD2pfzB',
  localDomain: 'https://bi.dev.beaconconnect.app',
  mainapiUrl: 'https://stakeholders-api.dev.beaconconnect.app/v1/core',
  messagingUrl: 'https://messaging-api.dev.beaconconnect.app/v1/messaging',
  dispatchUrl: 'https://dispatch-api.dev.beaconconnect.app/v1/dispatch',
  BIUrl: 'https://bi-api.dev.dw.beaconconnect.app/v1/bi',
  DWUIUrl: 'https://dw-bi.dev.dw.beaconconnect.app',
  enviromentType: 'dev',
  firebase: {
    storageBucket: 'ce-dev-cloudstg-us-east4',
  },
  versionDate,
};
